import useContent from "../hooks/useContent"
import styled from "styled-components"

import { LANGUAGE_DE, LANGUAGE_EN } from "../../shared/constants"

const Container = styled.div`
  position: absolute;
  top: 1.25rem;
  right: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 700;
`

const Button = styled.button`
  margin-left: 1.7rem;
  position: relative;
  color: ${({ isActive }) => (isActive ? "white" : "#595959")};
`

const Underline = styled.div`
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 140%;
  transform: translateX(-12%);
  height: 2px;
  background: white;
`

const LanguageButton = ({ text, isActive }) => {
  return (
    <Button isActive={isActive}>
      {text}
      {isActive && <Underline />}
    </Button>
  )
}

const LanguageSwitch = () => {
  const language = useContent({ path: "language" })

  return (
    <Container onClick={() => language.toggle()}>
      <LanguageButton isActive={language.current === LANGUAGE_DE} text={LANGUAGE_DE} />
      <LanguageButton isActive={language.current === LANGUAGE_EN} text={LANGUAGE_EN} />
    </Container>
  )
}

export default LanguageSwitch
